import {createSlice, PayloadAction} from '@reduxjs/toolkit';

const initialState: IRegisterStore = {};

export const registerStoreSlice = createSlice({
  name: 'registerStore',
  initialState,
  reducers: {
    addRegisterStoreFormData: (
      state,
      action: PayloadAction<IRegisterStore>,
    ) => {
      Object.keys(action.payload).map(
        //@ts-ignore
        item => (state[item] = action.payload[item]),
      );
    },
    preventRecall: (state, action: PayloadAction<boolean>) => {
      state.recall = action.payload;
    },

    // addPrimaryInfoRegisterStore: (
    //   state,
    //   action: PayloadAction<IRegisterStore>,
    // ) => {
    //   Object.keys(action.payload).map(item => {
    //     //@ts-ignore
    //     return (state[item] = action.payload[item]);
    //   });
    // },
    addOptionalRegisterStoreFormData: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.optionalRegisterFormData = action.payload;
    },

    optionalIsOpen: (state, action: PayloadAction<boolean>) => {
      state.optionalIsOpen = action.payload;
    },

    addCertificateLists: (
      state,
      action: PayloadAction<ICertificateItem[] | undefined>,
    ) => {
      state.certificate = action.payload;
    },

    resetRegisterStore: (state, action: PayloadAction<IRegisterStore>) => {
      state.name = '';
      state.supplier_profile_guid = '';
      state.logo = {file: null, logo: ''};
      state.license = {file: null, license: ''};
      state.store_photo = {file: null, store_photo: ''};
      state.national_card = {file: null, national_card: ''};
      state.lab_photo = {file: null, lab_photo: ''};
      state.address = '';
      state.land_line = '';
      state.phone_number = '';
      state.in_person_possibility = false;
      state.has_delivery = false;
      state.has_guarantee = false;
      state.title = '';
      state.about = '';
      state.location = [];
      state.certificate = [];
      state.lab_fields = [];
      state.optionalRegisterFormData = '';
      state.recall = false;
      state.storeType = '';
    },
  },
});

export const {
  resetRegisterStore,
  addRegisterStoreFormData,
  addOptionalRegisterStoreFormData,
  addCertificateLists,
  optionalIsOpen,
  preventRecall,
  // addLabInputs,
  // addPrimaryInfoRegisterStore,
} = registerStoreSlice.actions;

export default registerStoreSlice.reducer;
